module.exports = __webpack_public_path__ + "media/niacinamide-small.2a99fc34.mp4";